<div mat-dialog-title class="adlg-titlebar">
  <span class="adlg-sev-dot" [ngClass]="severityClass"></span>
  <span class="adlg-title">{{ data.alert.subject }}</span>
  <button mat-icon-button class="adlg-close" (click)="close()" [attr.aria-label]="'@close' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="adlg">
  <div class="adlg-meta">
    <span class="adlg-sev-label" [ngClass]="severityClass">{{ data.alert.severity }}</span>
    <span class="adlg-count">{{ data.alert.count }}×</span>
    <span class="adlg-time" [matTooltip]="data.alert.lastFiredAtUtc | date:'medium'">
      {{ '@lastFired' | translate }}: {{ data.alert.lastFiredAtUtc | timeAgo }}
    </span>
  </div>

  <div class="adlg-asset" *ngIf="data.vehicleName || data.vin || vehicleLocation">
    <div class="adlg-info-cell" *ngIf="data.vehicleName">
      <div class="adlg-info-label">{{ '@vehicleName' | translate }}</div>
      <div class="adlg-info-value">{{ data.vehicleName }}</div>
    </div>
    <div class="adlg-info-cell" *ngIf="data.vin">
      <div class="adlg-info-label">{{ '@vin' | translate }}</div>
      <div class="adlg-info-value">{{ data.vin }}</div>
    </div>
    <div class="adlg-info-cell" *ngIf="vehicleLocation">
      <div class="adlg-info-label">{{ '@location' | translate }}</div>
      <div class="adlg-info-value">{{ vehicleLocation }}</div>
    </div>
  </div>

  <div class="adlg-section" *ngIf="showCase && caseStatus">
    <div class="adlg-section-title">
      {{ '@case' | translate }}<span class="adlg-case-number" *ngIf="caseStatus.orderNumber"> #{{ caseStatus.orderNumber }}</span>
    </div>
    <div class="adlg-case">
      <span class="adlg-case-chip">{{ caseStatus.statusLabel }}</span>
    </div>
  </div>

  <div *ngIf="loading" class="adlg-loading">
    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
  </div>

  <div *ngIf="error && !loading" class="adlg-error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ '@loadError' | translate }}</span>
  </div>

  <ng-container *ngIf="!loading && !error">
    <div class="adlg-section" *ngIf="message">
      <div class="adlg-section-title">{{ '@message' | translate }}</div>
      <div class="adlg-message">{{ message }}</div>
    </div>

    <div class="adlg-section" *ngIf="faults.length">
      <div class="adlg-section-title">{{ '@faults' | translate }}</div>
      <div class="adlg-fault-list">
        <div class="adlg-fault-card" *ngFor="let fault of faults">
          <div class="adlg-fault-head">
            <mat-icon class="adlg-fault-flag" color="warn" *ngIf="fault.triggeredAlert"
                      [matTooltip]="'@alerted' | translate">flag</mat-icon>
            <span class="adlg-fault-protocol" [class.j1939]="fault.protocol === 'J1939'">{{ fault.protocol }}</span>
            <span class="adlg-fault-count" *ngIf="fault.faultCount">{{ fault.faultCount }}×</span>
            <span class="adlg-fault-date" [matTooltip]="fault.faultDateUtc | date:'medium'">
              {{ fault.faultDateUtc | timeAgo }}
            </span>
          </div>
          <div class="adlg-fault-desc" *ngIf="fault.description">{{ fault.description }}</div>
          <div class="adlg-fault-line">
            <b>{{ '@controller' | translate }}</b>:
            <span *ngIf="fault.faultType">{{ fault.faultType }}: </span>{{ fault.controller }}<span *ngIf="fault.controllerDisplay"> - {{ fault.controllerDisplay }}</span>
          </div>
          <div class="adlg-fault-line">
            <b>{{ '@faultCode' | translate }}</b>:
            {{ fault.faultCode }}<span *ngIf="fault.faultCodeDisplay"> - {{ fault.faultCodeDisplay }}</span>
          </div>
          <div class="adlg-fault-line">
            <b>{{ '@failureCode' | translate }}</b>:
            {{ fault.failureCode }}<span *ngIf="fault.failureCodeDisplay"> - {{ fault.failureCodeDisplay }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button *ngIf="showCase && caseActionReady" (click)="viewCase()">
    {{ (caseStatus?.hasCase ? '@viewCase' : '@createCase') | translate }}
    <mat-icon class="adlg-btn-icon">{{ caseStatus?.hasCase ? 'open_in_new' : 'note_add' }}</mat-icon>
  </button>
  <button mat-flat-button color="primary" (click)="viewAlert()">
    {{ '@viewAlert' | translate }}
    <mat-icon class="adlg-btn-icon">open_in_new</mat-icon>
  </button>
</mat-dialog-actions>
